<template>
    <RecommendedItem
        v-if="items.length > 0"
        :title="$t('LandingPage.recommended_items_customer_specific_courses_title')"
        :button-label="$t('General.see_all')"
        @buttonClick="goToUserSpecificPackage(getUserSpecificPackageSlug)"
    >
        <CarouselCourses theme="dark" :courses="items" />
    </RecommendedItem>
</template>

<script>
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import CarouselCourses from 'components/user/summary/carousel/CarouselCourses'
    import { mapGetters } from 'vuex'
    import withLanguage from 'components/landingpage/recommended-items/mixins/with-language'

    export default {
        components: { CarouselCourses, RecommendedItem },
        computed: {
            ...mapGetters({
                items: 'Courses/getCustomerSpecificCourses',
                userAccessablePackages: 'User/getUserAccessablePackages'
            }),
            getUserSpecificPackageSlug () {
                return this.userAccessablePackages.find(userPackage => userPackage.isCustomerSpecific === true).code
            }
        },
        data () {
            return {
                storeUpdateContentAction: 'Courses/loadCustomerSpecificCourses'
            }
        },
        methods: {
            goToUserSpecificPackage (packageSlug) {
                this.$store.dispatch('Search/clearAllFilters')
                this.$store.dispatch('Search/setMainPackage', packageSlug)
                this.$router.push({ name: 'learning-paths', params: { packageSlug } })
            }
        },
        mixins: [withLanguage]
    }
</script>
